<template>
  <div>
    <hora>
      <div v-if="project" >
        <div class="form" :style="{borderColor: project.icc}">
          <div class="project-title" :style="{backgroundColor: project.icc}">{{project.codename}}</div>
          <div class="form-field-group">
            <div class="form-field">
              <label>Kunde</label>
              <span>{{project.customer}}</span>
            </div>
            <div class="form-field">
              <label>Projekt</label>
              <span>{{project.project}}</span>
            </div>
            <div class="form-field">
              <label>Kennung</label>
              <select @change="changeProject">
                <option v-for="proj in $store.state.projects" v-if="proj.track === project.track" :selected="proj.identifier === project.identifier" :value="proj.identifier">
                  {{proj.identifier}}
                </option>
              </select>
            </div>
          </div>
          <div class="form-field">
            <label>Anmerkung</label>
            <auto-textarea>
              <textarea v-model="note"></textarea>
            </auto-textarea>
          </div>
          <div class="form-field-group">
            <div class="form-field">
              <label>Beginn</label>
              <div class="input-flex">
                <input class="number-font" v-model="start_date_inp"/>
                <input class="number-font" v-model="start_time_inp"/>
              </div>
            </div>

            <div class="form-field">
              <label>Ende</label>
              <div class="input-flex">
                <input class="number-font" v-model="end_date_inp"/>
                <input class="number-font" v-model="end_time_inp"/>
              </div>
            </div>
          </div>
          <div class="form-field-group">
            <div class="form-field">
              <label>Stunden</label>
              <div class="number-font">{{total_display}}</div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link tag="button" :style="{backgroundColor: project.icc}" :to="{name: 'user_home'}"><i class="material-icons">close</i></router-link>
          <button :style="{backgroundColor: project.icc}" class="timer" @click="stop_timer" v-if="timer_active"><i class="material-icons">stop</i></button>
          <button :style="{backgroundColor: project.icc}" class="timer" @click="start_timer" v-else><i class="material-icons">play_arrow</i></button>
          <button :style="{backgroundColor: project.icc}" @click="save"><i class="material-icons">check</i></button>
        </div>
        <entries :project="project.identifier" :track="project.track" :year="year" :month="month" :wage="project.wage"></entries>
      </div>
      <p v-else>Project not found.</p>
    </hora>
  </div>
</template>

<script>
  import Hora from '@/layouts/Hora.vue'
  import AutoTextarea from '@/components/AutoTextarea.vue'
  import Entries from '@/components/Entries.vue';

export default {
  name: 'project_start',
  components: {Hora,AutoTextarea,Entries},
  data() {
    let now = new Date();
    return {
      project: null,
      start: this.dateToArr(now),
      end: null,
      timer_active: false,
      note: null,
      code: 'tt',
      start_time_inp: this.timeDisplay(now),
      start_date_inp: this.dateDisplay(now),
      end_time_inp: null,
      end_date_inp: null,
      year: this.$route.query.hasOwnProperty("year") ? parseInt(this.$route.query.year) : null,
      month: this.$route.query.hasOwnProperty("month") ? parseInt(this.$route.query.month) : null
    }
  },
  computed: {
    total() {
      let end_date = this.end_date;
      let start_date = this.start_date;
      if (end_date === null || start_date === null || end_date < start_date) return null;
      return Math.abs(end_date - start_date) / 36e5;
    },
    total_display() {
      let total = this.total;
      let total_floor = Math.floor(total);
      if (isNaN(total))
        return null;
      else
        return `${total_floor},${("00" + ((total - total_floor) * 100).toFixed(0)).substr(-2,2)}`;
    },
    start_date() {
      return this.arrToDate(this.start);
    },
    end_date() {
      return this.arrToDate(this.end);
    },
  },
  watch: {
    start_date_inp(val) {
      this.setDateArr(val, this.start_time_inp, 'start');
      this.end_date_inp = val;
    },
    start_time_inp(val) {
      this.setDateArr( this.start_date_inp, val, 'start');
      this.end_time_inp = val;
    },
    end_date_inp(val) {
      this.setDateArr(val, this.end_time_inp, 'end');
    },
    end_time_inp(val) {
      this.setDateArr(this.end_date_inp, val, 'end');
    }
  },
  methods: {
    setDateArr(date, time, target) {
      time = time ? time.split(':') : null;
      date = date ? date.split('.') : null;
      let t = this[target] ? [...this[target]] : [];

      if (date && date.length === 3) {
        let year = parseInt(date[2]);
        if (year < 100) {
          let now = new Date();
          year = Math.floor(parseInt(now.getFullYear()) / 100) * 100 + year;
        }
        t[0] = year;
        t[1] = parseInt(date[1]);
        t[2] = parseInt(date[0]);
      }

      if (time && time.length >= 2) {
        let seconds = 0;
        if (time.length > 2) {
          seconds = time[2];
        }
        t[3] = parseInt(time[0]);
        t[4] = parseInt(time[1]);
        t[5] = parseInt(seconds);
      }

      for (let i = 0; i < t.length; ++i) {
        if (isNaN(t[i])) {
          this.$set(this, target, null);
          return;
        }
      }

      this.$set(this, target, t);
    },
    timeDisplay(date) {
      if (date === null) return null;
      return `${('00' + date.getHours()).substr(-2,2)}:${('00' + date.getMinutes()).substr(-2,2)}:${('00' + date.getSeconds()).substr(-2,2)}`
    },
    dateDisplay(date) {
      if (date === null) return null;
      return `${('00' + date.getDate()).substr(-2,2)}.${('00' + (date.getMonth()+1)).substr(-2,2)}.${date.getFullYear()}`
    },
    arrToDate(inp) {
      if (inp === null) {
        return null;
      }
      let seconds = inp.length > 5 ? inp[5] : 0;
      let d = new Date(inp[0], inp[1] - 1, inp[2], inp[3], inp[4], seconds);
      return d;
    },
    dateToArr(date) {
      return [
        date.getFullYear(),
        date.getMonth()+1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      ]
    },
    initProject(projectIdentifier) {
      for (let i = 0; i < this.$store.state.projects.length; ++i) {
        if (this.$store.state.projects[i].identifier === projectIdentifier) {
          this.project = this.$store.state.projects[i];
          break;
        }
      }
      setInterval(() => {
        let now = new Date();
        if (this.timer_active) {
          this.end = this.dateToArr(now);
          this.end_time_inp = this.timeDisplay(this.end_date);
          this.end_date_inp = this.dateDisplay(this.end_date);
        }
      }, 200);
    },
    changeProject(e) {
      this.$router.push({
        name: 'hora_project_start',
        params: {
          projectIdentifier: e.target.value
        }
      })
    },
    start_timer() {
      this.end = this.start;
      this.timer_active = true;
    },
    stop_timer() {
      this.timer_active = false;
    },
    save() {
      this.$store.dispatch('addEntry', {
        project: this.project.identifier,
        note: this.note,
        code: this.code,
        start: [
          this.start_date.getFullYear(),
          this.start_date.getMonth() + 1,
          this.start_date.getDate(),
          this.start_date.getHours(),
          this.start_date.getMinutes(),
          this.start_date.getSeconds()
        ],
        end: [
          this.end_date.getFullYear(),
          this.end_date.getMonth() + 1,
          this.end_date.getDate(),
          this.end_date.getHours(),
          this.end_date.getMinutes(),
          this.end_date.getSeconds()
        ]
      });
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          year: this.start_date.getFullYear(),
          month: this.start_date.getMonth() + 1
        }
      });
    }
  },
  beforeMount() {
    this.initProject(this.$route.params.projectIdentifier);
  },
  beforeRouteUpdate(to, _, next) {
    this.initProject(to.params.projectIdentifier);
    next();
  }
}
</script>


<style lang="sass" scoped>
  .project-title
    font-size: 1.5em
    padding: 0.5em
    text-align: center
    color: white
    text-transform: uppercase
    font-weight: 600

  button.timer
    text-align: center
    color: white
    border-radius: 100%
    border: 0
    display: block
</style>
